import { useEffect, useState } from 'react';
import { Button, Input, ModalV2 as Modal } from '@utilities';
import styles from '../../_index.module.scss';

export interface RenameProjectModalProps {
  handleRenameProject: ({
    projectSessionId,
  }: {
    projectSessionId: string;
    renamedProject: string;
  }) => void;
  isModalActive: boolean;
  projectName: string;
  projectSessionId: string;
  setIsModalActive: (isActive: boolean) => void;
}

const RenameProjectModal = ({
  handleRenameProject,
  isModalActive,
  projectName,
  projectSessionId,
  setIsModalActive,
}: RenameProjectModalProps) => {
  const [renamedProject, setRenamedProject] = useState(projectName);

  useEffect(() => {
    if (isModalActive) {
      setRenamedProject(projectName);
    }
  }, [isModalActive]);

  return (
    <Modal
      buttons={[
        <Button
          key="cancel-btn"
          onClick={() => setIsModalActive(false)}
          text="Cancel"
          variant="secondary"
        />,
        <Button
          isDisabled={!renamedProject?.trim() || renamedProject.trim() === projectName}
          key="submit-btn"
          onClick={() => {
            setIsModalActive(false);
            handleRenameProject({
              projectSessionId: projectSessionId,
              renamedProject: renamedProject.trim(),
            });
          }}
          text="Save"
        />,
      ]}
      isActive={isModalActive}
      onClose={() => setIsModalActive(false)}
      title="Rename"
    >
      <Input
        aria-label="Rename Project"
        className={styles['rename-project-input']}
        id="rename-project-input"
        label="Project Name"
        onChange={(value) => setRenamedProject(value as string)}
        value={renamedProject ? renamedProject : ''}
      />
    </Modal>
  );
};

export default RenameProjectModal;
